import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'src/app/services/cookie.service';

@Component({
  selector: 'app-redirect-layout',
  templateUrl: './redirect-layout.component.html',
  styleUrls: ['./redirect-layout.component.scss']
})
export class RedirectLayoutComponent {
  @Input() data: any;

  ngOnInit() {
    window.location.href = this.data.redirect;
    
  }

}